import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "forgettingToLog",
  "tooTimeConsuming",
  "hardToEstimate",
  "manualEntryTedious",
  "dontKnowWhatToTrack",
  "haventTried",
] as const

export default function TrackingChallenges() {
  return (
    <MultiSelectPage
      translationKey="trackingChallenges"
      options={OPTIONS}
      noneOptionKey="haventTried"
    />
  )
}
